import { useLazyQuery } from '@apollo/client';
import getMetadataQuery from '../queries/metadata/getMetadataQuery';
import { useQuery } from './useQuery';

const useMetadata = ({
  parentId,
  ssr = false,
  lazy = false,
  skip = false,
}) => {

  const Query = getMetadataQuery();

  const opts = {
    ssr,
    skip,
    errorPolicy: 'all',
    variables: {
      parentId,
    }
  };

  if (lazy) {
    return useLazyQuery(Query, opts);
  }
  return useQuery(Query, opts);

};

export default useMetadata;
